export default __webpack_public_path__ + "static/media/streamer_avatar9.c087eccc.png";